<template>
    <el-table :data="users" border>
        <el-table-column align="center" label="用户ID" prop="userId" width="100" />
        <el-table-column align="center" label="用户名" prop="userName" />
        <el-table-column align="center" label="手机号" prop="mobile" />
        <el-table-column align="center" label="角色" prop="role">
            <template slot-scope="scope">
                {{
                roleMap[scope.row.role]
                }}
            </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
                <el-button @click="clickEdit(scope.row)" size="mini">修改权限</el-button>
                <el-button
                    @click="clickEnable(scope.row)"
                    size="mini"
                    type="danger"
                >{{ enableMap[scope.row.enable] }}</el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
    ROLE,
    DIALOG_EDIT,
    ENABLE_TRUE,
    ENABLE_FALSE,
} from '../../libs/enum.js';

const { mapState, mapActions } = createNamespacedHelpers('user');

export default {
    data() {
        return {
            enableMap: {
                [ENABLE_TRUE]: '启用',
                [ENABLE_FALSE]: '禁用',
            },
        };
    },
    computed: {
        ...mapState({
            users: state => state.users,
        }),
        roleMap() {
            const obj = {};
            ROLE.forEach(item => {
                obj[item.value] = item.label;
            });
            return obj;
        },
    },
    methods: {
        ...mapActions(['changeDialog', 'changeForm', 'enableUser']),
        clickEdit(data) {
            const user = {
                userId: data.userId,
                name: data.userName,
                mobile: data.mobile,
                role: data.role,
            };
            this.changeForm(user);
            this.changeDialog({ type: DIALOG_EDIT, visible: true });
        },
        clickEnable({ userId, enable }) {
            const text = this.enableMap[enable];
            this.$confirm(`是否要${text}账号？`, '提示', {
                type: 'warning',
            })
                .then(async () => {
                    await this.enableUser({ userId, enable: enable ? 0 : 1 });
                    this.$message.success(`${text}成功！`);
                })
                .catch(() => {
                    this.$message.info(`取消${text}`);
                });
        },
    },
};
</script>

<style></style>
